import { FormLabel } from './form-label'
import type { AnyFieldApi } from '@tanstack/react-form'
import { Input } from '@/components/ui/input'

export interface FormInputProps extends React.ComponentProps<typeof Input> {
  field: AnyFieldApi
  label?: string
  helper?: React.ReactNode
}

export function FormInput({ field, label, helper, ...props }: FormInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (props.type === 'number') {
      field.handleChange(value === '' ? '' : parseFloat(value))
    } else {
      field.handleChange(value)
    }
  }

  return (
    <div className="gap-0">
      {label && (
        <FormLabel htmlFor={props.name} required={props.required}>
          {label}
        </FormLabel>
      )}
      <Input
        {...props}
        value={field.state.value ?? ''}
        onChange={handleChange}
        onBlur={field.handleBlur}
      />
      {helper ? (
        <p className="text-xs text-neutral-500 mt-1">{helper}</p>
      ) : null}
      {field.state.meta.isTouched && !field.state.meta.isValid ? (
        <p className="text-xs text-red-500">
          {field.state.meta.errors.join(', ')}
        </p>
      ) : null}
      <p className="text-xs">
        {field.state.meta.isValidating ? 'Validating...' : null}
      </p>
    </div>
  )
}
